import Header, { HeaderType } from '@/components/Layout/Header/Header';
import chat from '@/assets/chat.png';
import community from '@/assets/community.png';
import profile from '@/assets/chatProfile.png';
import searchIcon from '@/assets/searchicon.png';
import friendIcon from '@/assets/friendIcon.png';
import friendIconGroup from '@/assets/friendIcongroup.png';
import friendIcon2 from '@/assets/friendIcontwo.png';
import voiceCall from "@/assets/voicecall'.png";
import videoCall from '@/assets/videoCall.png';
import dots from '@/assets/threeDots.png';
import sendIcon from '@/assets/sendMessage.png';
import folder from '@/assets/doc.svg';
import linkIcon from '@/assets/link.png';
import cameraIcon from '@/assets/cameraicon.png';
import micIcon from '@/assets/micIcon.png';
import { getCustomerlist } from '@/api/Chat/getCustomerList';
import { useGetChatList } from '@/api/Chat/getChatList';
import { createChat } from '@/api/Chat/createChat';
import {
  Client as TwilioChatClient,
  Client,
  Conversation,
  Message as MessageType,
} from '@twilio/conversations';
import { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { User, ChatList } from '@/types/Chat';
import {
  clientInitializer,
  getCurrentUserDetails,
  getMessageListing,
  MessageListType,
  ChatUserTypes,
  formatMessageTime,
} from './event';
import moment from 'moment';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import ChatIllustration from '@/assets/chat.webp';
import { Button, Spinner } from '@/components/Elements';
import { ChatItem, MessageItem, ChatHeader, ChatInput } from './Componets';
import ChatLoader from '@/components/Elements/Loader/ChatLoader';
import { isPdf, isVideo, useSelectMultipleFile } from '@/hooks/useSelectMultipleFile';
import { uploadImage } from '@/api/uploadImage';
import { Box, Modal } from '@mui/material';
import Typography from '@mui/material/Typography';
import { Image } from '@/components/Elements/Image';
import Avatar from '@mui/material/Avatar';
import { useAuth } from '@/lib/auth';
import placeholder from '@/assets/placeholderImage.webp';
import delet from '@/assets/delet.svg';
import { getVideoCover } from '@/utils/getVideoCover';
import Footer from '@/components/Layout/Footer/Footer';

import {
  LeadingActions,
  SwipeableList,
  SwipeableListItem,
  SwipeAction,
  TrailingActions,
} from 'react-swipeable-list';
import 'react-swipeable-list/dist/styles.css';
import { deleteChat } from '@/api/Chat/deleteChat';
import { useNotificationStore } from '@/stores/notifications';
import { uploadThumbnail } from '@/api/uploadVideoThumbnail';

const style = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 570,
  bgcolor: 'background.paper',
  border: '1px solid #000',
  boxShadow: 24,
  p: 4,
};

export const Chat = () => {
  const navigate = useNavigate();
  const { addNotification } = useNotificationStore();

  const { user } = useAuth();
  const containerRef = useRef<null | HTMLElement>(null);

  const [searchParams] = useSearchParams();
  const id: string | null = searchParams.get('id');
  const sid: string | null = searchParams.get('sid');

  // const [image, setImage] = useState<string>('');
  const [customerList, setCustomerList] = useState<User[]>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredList, setFilteredList] = useState<ChatList[]>([]);

  const [conversation, setConversation] = useState<Conversation>();
  const [details, setDetails] = useState<ChatUserTypes>();
  const [messages, setMessages] = useState<MessageListType[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [message, setMessage] = useState('');
  const [type, setType] = useState('');

  const [loadings, setLoadings] = useState(false);
  const [preview, setPicturePreview] = useState<string>('');
  const [file, setFile] = useState<File | null>(null);
  const [mediaName, setName] = useState<string>('');
  const [open, setOpen] = useState(false);
  const [img, setImg] = useState('');
  const [thumbnail, setThumbnail] = useState<string>();
  const [phoneNumber, setPhoneNumber] = useState<string>();
  const [active, setActive] = useState<string>('client');
  const {
    data: chatData,
    isLoading: chatListLoading,
    refetch: refetchChatList,
  } = useGetChatList({ active });
  // useEffect(() => {
  //   const data = async () => {
  //     const res = await getCustomerlist();
  //     setCustomerList(res?.data);
  //     setFilteredList(res?.data);
  //     return res?.data;
  //   };
  //   data();
  // }, []);

  useEffect(() => {
    refetchChatList();
  }, [active]);

  const handleActive = (value: string) => setActive(value);
  const handdleClientConnection = async () => {
    const client = await clientInitializer();
    const conversation = await client.getConversationBySid(sid ?? ''); // Fetch the current conversation
    setConversation(conversation);

    const userDetails = await getCurrentUserDetails(conversation, id);
    setDetails(userDetails);

    const messages = await getMessageListing(conversation, id);
    setMessages(messages);
    setLoading(false);
    // Filter and handle the new message only if it belongs to the current conversation
    const adReceivedMessage = async (newMessage: MessageType) => {
      // Check if the message belongs to the current conversation
      if (newMessage.conversation.sid !== conversation.sid) {
        return; // Skip the message if it doesn't belong to the current conversation
      }
      const { body, author, timestamp, attributes, participantSid, identity } = newMessage?.state;
      const data = JSON.parse(body);
      const newMessageData: MessageListType = {
        message: data?.message,
        sendedType: author === id ? 'received' : 'sent',
        time: moment(timestamp).format('h:mm A'),
        fileName: data?.fileName,
        videoThumbnail: data?.videoThumbnail,
        messageTime: formatMessageTime(timestamp),
        author: author,
        seen: data?.seen,
        type: data?.type,
      };
      const currentMessages = messages || [];
      currentMessages?.push(newMessageData);
      setMessages(currentMessages);
    };
    // Event listener for new messages
    client.on('messageAdded', (newMessage: MessageType) => {
      try {
        adReceivedMessage(newMessage);
        refetchChatList();
      } catch (err) {
        console.log('Message receive handle failed:', err);
      }
    });
  };

  // useEffect(() => {
  //   const container = containerRef.current;
  //   // Ensure container is not null before attaching the scroll event
  //   if (container) {
  //     // Adding the event listener
  //     const handleScroll = () => {
  //       const isAtBottom = container.scrollHeight - container.scrollTop === container.clientHeight;

  //       if (isAtBottom) {
  //         const lastVisibleMessageIndex = messages.length - 1;
  //         updateLastMessage(lastVisibleMessageIndex);

  //         // Mark all visible messages as seen
  //         const updatedMessages = messages.map((message, index) => {
  //           if (index <= lastVisibleMessageIndex) {
  //             return { ...message, seen: true }; // Mark as seen for all visible messages
  //           }
  //           return message;
  //         });

  //         setMessages(updatedMessages);
  //       }
  //     };

  //     // Adding the scroll event listener
  //     container.addEventListener('scroll', handleScroll);

  //     // Cleanup the event listener on component unmount or when `containerRef.current` changes
  //     return () => {
  //       container.removeEventListener('scroll', handleScroll);
  //     };
  //   }
  // }, [messages]); // Re-run this effect whenever `messages` change

  // const updateLastMessage = async (lastMessageIndex: number) => {
  //   try {
  //     // Ensure the conversation is defined
  //     if (conversation) {
  //       await conversation.updateLastReadMessageIndex(lastMessageIndex);
  //       console.log(`Last read message index updated to: ${lastMessageIndex}`);
  //     }
  //   } catch (err) {
  //     console.error('Error updating last read message index:', err);
  //   }
  // };

  const handleImageChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setName(file.name);
      setFile(e.target.files[0]);
      setPicturePreview(URL.createObjectURL(file));
      try {
        const res = await uploadImage({ file });
        if (res?.url) {
          //setImage(res.url);
          setMessage(res.url);
          setType('1');
          if (isVideo(file.name)) {
            setType('2');
            const cov = await getVideoCover(file, 1.5);
            const data = await uploadThumbnail(cov);
            setThumbnail(data?.url);
          }
          if (isPdf(file.name)) {
            setType('3');
          }
        }
      } catch (error) {
        console.error('Error uploading image:', error);
      }
    }
  };

  useEffect(() => {
    if (file) {
      setLoadings(true);
      handleOpen();
      setLoadings(false);
    }
  }, [file, preview]);

  const handleSendMessage = async () => {
    if (message.trim() !== '') {
      message && setLoadings(true);
      try {
        // const mediaUrl = image ? image : null;
        // const sentMessage = await conversation?.sendMessage(message, {
        //   media: mediaUrl ?? '',
        //   mediaName: mediaName ?? '',
        //   seen: false,
        // });

        // const sentMessage = await conversation?.sendMessage("{ message: 'Hello' , type:'0'}");
        // const data = `{ message: ${message}, type: ${type},mediaName:${mediaName},thumbnail:${cover}, seen: false }`;

        const payload = {
          message,
          type,
          fileName: mediaName || '',
          videoThumbnail: thumbnail || '',
          seen: false,
        };
        const data = JSON.stringify(payload);
        const sentMessage = await conversation?.sendMessage(data);
        //const sentMessage = await conversation?.sendMessage(`{ 'message': ${message}, type: '0' }`);

        setMessage('');
        //setImage('');
        setName('');
        setType('');
        setThumbnail('');
        message && setLoadings(false);
        handleClose();

        // Scroll to the bottom of the conversation container
        if (containerRef.current) {
          containerRef.current.scrollTop = containerRef?.current?.scrollHeight;
        }

        // if (sentMessage) {
        //   const sentMessageIndex = messages.length; // This will be the last message's index in the conversation
        //   updateLastMessage(sentMessageIndex);
        // }
      } catch (err) {
        console.log('Error sending message', err);
      }
    }
  };

  const handleKeyPress = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent default behavior (like newline in textarea)
      handleSendMessage();
    }
  };

  // const handleCustomerList = (e: { target: { value: string } }) => {
  //   const query = e.target.value.toLowerCase();
  //   setSearchTerm(query);
  //   const queryWords = query.split(' ').filter((word) => word.length > 0);
  //   const filteredCustomers: any = customerList.filter((customer) => {
  //     return queryWords.every(
  //       (word) =>
  //         customer.firstName.toLowerCase().includes(word) ||
  //         customer.lastName.toLowerCase().includes(word)
  //     );
  //   });
  //   setFilteredList(filteredCustomers);
  // };

  const handleCustomerList = (e: { target: { value: string } }) => {
    const query = e.target.value.toLowerCase();
    setSearchTerm(query);
    const filteredCustomers = chatData?.filter((customer: ChatList) => {
      return user?.customer_id == customer?.customer_two_id
        ? customer.customer_one_name.toLowerCase().includes(query)
        : customer.customer_two_name.toLowerCase().includes(query);
    });

    setFilteredList(filteredCustomers || []);
  };

  const handleClick = async (customer: ChatList) => {
    try {
      setLoading(true);
      setSearchTerm(customer?.customer_two_name);
      setFilteredList([]);
      // const res = await createChat(customer?.id);
      // navigate(`/user/chat?id=${customer?.id}&sid=${res?.twilio_channel_sid}`);
      setMessage('');
      refetchChatList();
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
      setSearchTerm('');
    }
  };

  const hyanddleReset = () => {
    setLoading(true);
  };
  useEffect(() => {
    if (sid && id) {
      hyanddleReset();
      refetchChatList();
      handdleClientConnection();
    }
  }, [sid, id]);

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    //setImage('');
    setName('');
    setMessage('');
    setType('');
  };

  const formatMsgTime = (messageTime: string | number | Date) => {
    const messageMoment = moment(messageTime).local();
    const currentMoment = moment().local();
    if (messageMoment.isSame(currentMoment, 'day')) {
      return messageMoment.format('h:mm A');
    }
    if (messageMoment.isSame(currentMoment.subtract(1, 'days'), 'day')) {
      return 'Yesterday';
    }
    if (messageMoment.isSame(currentMoment, 'week')) {
      return messageMoment.format('dddd');
    }
    return messageMoment.format('DD/MM/YYYY');
  };

  useEffect(() => {
    const res = chatData?.filter((item: any) => {
      //details?.receiver?.id
      if (item?.customer_one_id == Number(id)) {
        setImg(item?.customer_one_image);
        setPhoneNumber(item?.customer_one_phone_number);
      }
      if (item?.customer_two_id == Number(id)) {
        setPhoneNumber(item?.customer_two_phone_number);
      }
    });
  }, [details, id]);
  console.log(messages);
  const handleDeleteChat = async (id: number) => {
    try {
      // const res: any = await deleteChat(id);
      // addNotification({
      //   type: 'success',
      //   title: 'Succes',
      //   message: res?.status_message,
      // });
      refetchChatList();
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    if (chatData?.length == 0) {
      //navigate('/user/chat');
    }
  }, [chatData]);

  const trailingActions = (id: number) => (
    <TrailingActions>
      <SwipeAction destructive={true} onClick={() => handleDeleteChat(id)}>
        <i className="fa fa-trash" style={{ fontSize: '20px', marginTop: '25px' }}></i>
      </SwipeAction>
    </TrailingActions>
  );
  return (
    <div className="chat-socket">
      {/* <Header type={HeaderType.LANDING} /> */}
      <div
        className="chat-box"
        style={{
          // marginTop: '140px',
          paddingTop: '20px',
          paddingBottom: '30px',
          background: '#D9D9D938',
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-lg-5 col-xxl-4  d-flex gap-2">
              <div className="chat-type-bar rounded-20 d-flex justify-content-between flex-col gap-4">
                <div className="">
                  <div className="chat text-center">
                    <img src={chat} className="d-block w-100" />
                    <span>Chat</span>
                  </div>
                  {/* <div className="community text-center">
                    <img src={community} className="d-block w-100" />
                    <span>Community</span>
                  </div> */}
                </div>

                <div
                  className="account-btn d-flex gap-2 flex-col align-items-center pointer"
                  onClick={() => {
                    navigate('/user/profile');
                  }}
                >
                  <Avatar
                    sx={{ bgcolor: '#000', color: '#E03150', fontSize: '25px', fontWeight: '700' }}
                  >
                    {user?.first_name[0]}
                  </Avatar>
                  <p>Profile</p>
                </div>
              </div>
              <div className="chat-list rounded-20 p-4" style={{ background: '#ffffff' }}>
                <p className="text-dark fw-semibold list-heading">Chat</p>
                <form action="" id="searchForm">
                  <div className="form-block position-relative">
                    <span className="position-absolute srch-icn">
                      <img src={searchIcon} alt="" width={25} />
                    </span>
                    <input
                      type="text"
                      name="search"
                      id="search"
                      placeholder="Search"
                      value={searchTerm}
                      onChange={handleCustomerList}
                    />
                  </div>

                  {/* {searchTerm && (
                    <div className="dropdown-list">
                      {filteredList.length > 0 ? (
                        <ul>
                          {filteredList.map((customer: ChatList, index) => (
                            <li
                              className="pointer"
                              key={index}
                              onClick={() => handleClick(customer)}
                            >
                              {customer?.customer_two_name}
                              //  {customer?.firstName} {customer?.lastName} 
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <></>
                        // <p className=''>No results found</p>
                      )}
                    </div>
                  )} */}
                </form>

                <div className="chat-category d-flex justify-content-between align-items-center mb-5">
                  <div
                    className={`${active == 'client' && 'active'} semi-bold`}
                    onClick={() => handleActive('client')}
                  >
                    Client
                  </div>
                  <div
                    className={`${active == 'agency' && 'active'} semi-bold`}
                    onClick={() => handleActive('agency')}
                  >
                    Agency
                  </div>
                  <div
                    className={`${active == 'lawyer' && 'active'} semi-bold`}
                    onClick={() => handleActive('lawyer')}
                  >
                    Lawyer
                  </div>
                </div>

                {chatListLoading ? (
                  <ChatLoader />
                ) : (
                  <div className="friends-list">
                    {(filteredList.length === 0 && searchTerm.length > 0) ||
                      chatData?.length == 0 ? (
                      <p className="text-center">No chats found</p>
                    ) : (
                      (filteredList.length > 0 ? filteredList : chatData)?.map(
                        (item: ChatList, index: number) => {
                          return (
                            <div
                              className="chat-slide d-flex gap-3 cursor-pointer align-items-center"
                              key={index}
                            >
                              <SwipeableList>
                                <SwipeableListItem trailingActions={trailingActions(item?.id)}>
                                  {/* <div className="friendIcon active"> */}

                                  {/* <div>
                                  </div> */}
                                  <div className="friendIcon ">
                                    <img
                                      src={
                                        user?.customer_id == item?.customer_two_id
                                          ? item?.customer_one_image
                                          : item?.customer_two_image
                                      }
                                      alt="profile"
                                      className="d-block w-100 h-100 rounded"
                                      onError={({ currentTarget }) => {
                                        currentTarget.onerror = null;
                                        currentTarget.src = placeholder;
                                      }}
                                    />
                                  </div>

                                  <div
                                    className="friendDetail d-flex flex-col ms-2"
                                    onClick={() => {
                                      setMessage('');
                                      navigate(
                                        `/user/chat?id=${user?.customer_id == item?.customer_two_id
                                          ? item?.customer_one_id
                                          : item?.customer_two_id
                                        }&sid=${item?.twilio_channel_sid}`
                                      );
                                      setImg('');
                                      // const message = await conversation.getMessageBySid(messageSid);
                                      // await message.update({
                                      //   attributes: { ...message.attributes, seen: true },
                                      // });
                                    }}
                                  >
                                    <div className="friendNameTime d-flex gap-2 mb-1">
                                      <p className="text-dark f-14 font-semibold">
                                        {user?.customer_id == item?.customer_two_id
                                          ? item?.customer_one_name
                                          : item?.customer_two_name}
                                      </p>
                                      <p className="last-online f-13 text-dark">
                                        {item?.message_date && formatMsgTime(item?.message_date)}
                                      </p>
                                    </div>
                                    <div className="chat-detail d-flex justify-content-between">
                                      <p className="f-13">{item?.last_message}</p>
                                      {/* <div className="message-count active">12</div> */}
                                    </div>
                                  </div>
                                </SwipeableListItem>
                              </SwipeableList>
                            </div>
                          );
                        }
                      )
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className="col-md-12 col-lg-7 col-xxl-8">
              {chatListLoading || loading ? (
                <div className="mt-5 pt-5">
                  <ChatLoader />
                </div>
              ) : !sid && !id ? (
                <img className="illustrstion " src={ChatIllustration} />
              ) : (
                <div
                  className="chat-socket-box rounded-30 pt-4 pb-5"
                  style={{ background: '#fff' }}
                >
                  <ChatHeader
                    name={
                      user?.customer_id == details?.receiver?.id
                        ? details?.sender?.name
                        : details?.receiver?.name
                    }
                    image={
                      user?.customer_id == details?.receiver?.id
                        ? details?.sender?.image
                        : details?.receiver?.image
                          ? details?.receiver?.image
                          : img
                    }
                    id={
                      user?.customer_id == details?.receiver?.id
                        ? details?.sender?.id
                        : details?.receiver?.id ?? 0
                    }
                    phoneNumber={phoneNumber}
                  />

                  <div className="chat-messages pt-4 pb-4" ref={containerRef}>
                    {messages &&
                      messages?.map((items, index) => {
                        let showMessageTime = false;
                        if (
                          index === 0 ||
                          items?.messageTime !== messages[index - 1]?.messageTime
                        ) {
                          showMessageTime = true;
                        }
                        return (
                          <>
                            {showMessageTime && (
                              <p className="text-center">
                                <span className="bg-dark text-light py-1 px-2 f-13 rounded">
                                  {items?.messageTime}
                                </span>
                              </p>
                            )}
                            <MessageItem
                              type={items?.sendedType == 'sent' ? 1 : 2}
                              message={items?.message}
                              date={items?.time}
                              name={
                                items?.sendedType == 'sent'
                                  ? details?.sender?.name
                                  : details?.receiver?.name
                              }
                              image={
                                items?.sendedType == 'sent'
                                  ? details?.sender?.image
                                  : details?.receiver?.image
                                    ? details?.receiver?.image
                                    : img
                              }
                              videoThumbnail={items?.videoThumbnail}
                              mediaName={items?.fileName}
                              msgType={items?.type}
                              seen={items?.seen}
                              profileImg={user?.profile_image}
                            />
                            {/* {items.seen && <span className="seen-status">Seen</span>} */}
                          </>
                        );
                      })}
                  </div>
                  <div
                    className="message-write-box rounded-15 d-flex ps-4 align-items-center gap-4"
                    style={{ background: '#F7F7F7' }}
                  >
                    <div className="write-icons d-flex gap-3 align-items-center">
                      <span className="uploadLink cursor-pointer">
                        <label htmlFor="chatDoc" className="pb-0">
                          <img
                            src={linkIcon}
                            alt=""
                            className="d-block w-100 pointer"
                            style={{ maxWidth: '24px' }}
                          />

                          <input
                            accept=".pdf, .doc , .csv , .xlsx"
                            onChange={handleImageChange}
                            type="file"
                            id="chatDoc"
                            className="d-none"
                          />
                        </label>
                      </span>

                      <span className="cameraIcon cursor-pointer">
                        <label htmlFor="chatImage" className="pb-0">
                          <img
                            src={cameraIcon}
                            alt=""
                            className="d-block w-100 pointer"
                            style={{ maxWidth: '24px' }}
                          />
                        </label>

                        <input
                          accept="image/* , video/*"
                          onChange={handleImageChange}
                          type="file"
                          id="chatImage"
                          className="d-none"
                        />
                      </span>
                      {/* <span className="micIcon cursor-pointer">
                        <img
                          src={micIcon}
                          alt=""
                          className="d-block w-100"
                          style={{ maxWidth: '24px' }}
                        />
                      </span> */}
                    </div>
                    <div className="text-write-input w-100">
                      <input
                        type="text"
                        placeholder="Type your message here"
                        value={type == '0' ? message : ''}
                        className="bg-transparent w-100"
                        onKeyDown={handleKeyPress}
                        onChange={(e) => {
                          const msg = e.target.value;
                          setMessage(msg);
                          setType('0');
                        }}
                      />
                    </div>
                    <button
                      className="sendButton rounded-15 py-3 px-4"
                      type="submit"
                      style={{ background: '#FF385C' }}
                      onClick={handleSendMessage}
                    >
                      <img
                        src={sendIcon}
                        alt=""
                        className="d-block w-100"
                        style={{ maxWidth: '26px' }}
                      />
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="chatPage">
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className=""
        >
          <Box className="chat-modal" sx={style}>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              {loadings || !message ? (
                <div className="d-flex justify-center my-5">
                  <Spinner />
                </div>
              ) : (
                <div className="chatForm">
                  <div className="recivers-msg mt-3">
                    {isVideo(message) ? (
                      <video className="set-document-image" width={200} height={200} controls>
                        <source src={message} type={`video/${message?.split('.').pop()}`} />
                      </video>
                    ) : (
                      preview && <Image src={preview} alt="image" imagefallback={folder} />
                    )}
                  </div>
                  {/* {preview && (
                    <Image src={preview} alt="image" imagefallback={folder} />
                  )} */}
                  {/* // <img
                  //   src={preview ?? folder}
                  //   alt=""
                  //   height={200}
                  //   width={200}
                  //   className="chatImage p-2"
                  // /> */}

                  <div className="chat-box float-end mt-3">
                    <button
                      className="sendButton rounded-15 py-3 px-4"
                      type="submit"
                      style={{ background: '#FF385C' }}
                      onClick={handleSendMessage}
                    >
                      <img
                        src={sendIcon}
                        alt=""
                        className="d-block w-100"
                        style={{ maxWidth: '26px' }}
                      />
                    </button>
                  </div>
                </div>
              )}
            </Typography>
          </Box>
        </Modal>
      </div>
      <Footer />
    </div>
  );
};
